module.exports = __webpack_public_path__ + "img/screenshot.4118ea4f.png";